export const MIN_BITRATE_HD = 2000000
